import _typeof from "@babel/runtime/helpers/typeof";
import React, { useCallback, useContext } from 'react';
var Context = /*#__PURE__*/React.createContext({
  focusInput: undefined
});
export var InputContext = function InputContext(_ref) {
  var children = _ref.children,
    forwardRef = _ref.forwardRef;
  var focusInput = useCallback(function () {
    if (_typeof(forwardRef) === 'object') {
      var _forwardRef$current;
      forwardRef === null || forwardRef === void 0 || (_forwardRef$current = forwardRef.current) === null || _forwardRef$current === void 0 || _forwardRef$current.focus();
    }
  }, [forwardRef]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      focusInput: focusInput
    }
  }, children);
};
export var useInputContext = function useInputContext() {
  return useContext(Context);
};